import * as React from "react";
import {
  BottomSwoosh,
  Container,
  Title,
  Wrapper,
  BannerWrapper,
  Description,
  TitleSection,
  LoadingWrapper,
  EmptyStateWrapper,
  InnerContainer,
  SliderContainer,
} from "./TimelineSection.styled";
import Tabs from "../../../atoms/Tabs/Tabs";
import CardKota from "../../../atoms/CardKota";
import {
  useFetchEventSeries,
  useFetchEventSeriesDetail,
} from "../../../../networks/resolvers";
import useDebounce from "../../../../hooks/useDebounce";
import Skeleton from "react-loading-skeleton";
import { ReactComponent as EmptyState } from "./assets/empty-state.svg";
import { ReactComponent as EmptyStateDesktop } from "./assets/empty-state-desktop.svg";
import SliderWrapper from "../../../atoms/SliderWrapper";
import useWindowSize from "../../../../hooks/useWindowSize";
import moment from "moment";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const TimelineSection = () => {
  const [slug, setSlug] = React.useState();
  const [isChangeTab, setIsChangeTab] = React.useState(false);

  const { size } = useWindowSize();

  const isMobile = size?.width <= 768;

  const { data: dataEventRaw, isFetching: fetchingEventSeries } =
    useFetchEventSeries();

  const dataEventSeries =
    dataEventRaw?.data?.data?.eventSeries?.filter(
      (val) => val?.slug !== "soc"
    ) ?? [];

  const dataEventSeriesActiveTab = React.useMemo(() => {
    const data = [...dataEventSeries]?.map((data) => {
      return {
        ...data,
        title: data?.main_region_name,
      };
    });

    return data;
  }, [dataEventSeries]);

  const dataMainRegion = React.useMemo(() => {
    if (!dataEventSeriesActiveTab) return {};
    return dataEventSeriesActiveTab?.map((data, idx) => ({
      id: idx,
      title: data?.main_region_name,
      slug: data?.slug,
    }));
  }, [dataEventSeriesActiveTab]);

  const {
    data: dataEventSeriesDetailRaw,
    isFetching: fetchingEventSeriesDetail,
  } = useFetchEventSeriesDetail(
    slug ?? dataMainRegion?.[0]?.slug,
    !isChangeTab && !fetchingEventSeries
  );

  const dataEventSeriesDetail =
    dataEventSeriesDetailRaw?.data?.data?.eventSeries?.[0];

  const isLoading =
    fetchingEventSeries || fetchingEventSeriesDetail || isChangeTab;

  const isShowCityCard = dataEventSeriesDetail?.region_series?.length > 0;

  const handleChangeTab = (data) => {
    setIsChangeTab(true);
    setSlug(data?.slug);
  };

  const handleOnClick = (data) => {
    console.log(data);
    setIsChangeTab(false);
    setSlug(data?.slug);
  };

  useDebounce(
    () => {
      if (slug && isChangeTab) {
        setIsChangeTab(false);
      }
    },
    600,
    [slug]
  );

  return (
    <Container id="timeline">
      <InnerContainer>
        <Wrapper>
          <Title>Piala by.U 2024 Series</Title>

          <Tabs
            onChange={handleChangeTab}
            onClick={handleOnClick}
            // swipeable
            tabList={dataMainRegion}
          />

          {isLoading ? (
            <>
              <LoadingWrapper>
                <Skeleton width="100%" height={168} borderRadius={16} />
              </LoadingWrapper>
              <LoadingWrapper>
                <Skeleton width="100%" height={20} borderRadius={16} />
              </LoadingWrapper>
              <LoadingWrapper>
                <Skeleton width="20%" height={20} borderRadius={16} />
              </LoadingWrapper>
              <SliderWrapper showItems={3} totalData={5}>
                {() => (
                  <>
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                  </>
                )}
              </SliderWrapper>
            </>
          ) : (
            <>
              {dataEventSeriesDetail?.region_series?.length > 0 ? (
                <>
                  <BannerWrapper>
                    <img
                      src={`${imgPath}/${
                        dataEventSeriesDetail?.[
                          isMobile ? "key_visual_mobile" : "key_visual"
                        ]
                      }`}
                    />
                  </BannerWrapper>
                  <Description>
                    {dataEventSeriesDetail?.event_description}
                  </Description>

                  <TitleSection>Cek Informasi Per kota</TitleSection>
                </>
              ) : (
                <>
                  <EmptyStateWrapper>
                    {isMobile ? <EmptyState /> : <EmptyStateDesktop />}
                  </EmptyStateWrapper>
                  <Description style={{ textAlign: "center" }}>
                    Segera!!! Akan hadir di Kotamu Piala by.U 2024, jangan
                    sampai kelewatan!
                  </Description>
                </>
              )}
            </>
          )}
        </Wrapper>
        <SliderContainer>
          {!isLoading && isShowCityCard && (
            <SliderWrapper
              showDotsIndicator={isMobile ? false : true}
              showItems={isLoading ? 0 : 3}
              showArrow={dataEventSeriesDetail?.region_series?.length > 3}
              step={1}
              style={
                !isMobile
                  ? {
                      width:
                        dataEventSeriesDetail?.region_series?.length > 3
                          ? "100%"
                          : "978px",
                    }
                  : {}
              }
              cardWrapperStyle={!isMobile ? { width: "100%" } : {}}
              totalData={dataEventSeriesDetail?.region_series?.length ?? 0}
              swipeable={false}
            >
              {({ cardWidth }) => {
                return (
                  <>
                    {dataEventSeriesDetail?.region_series?.map((data, idx) => (
                      <CardKota
                        key={idx}
                        data={data}
                        cardWidth={`${cardWidth}px`}
                      />
                    ))}
                  </>
                );
              }}
            </SliderWrapper>
          )}
        </SliderContainer>
      </InnerContainer>
      <BottomSwoosh />
    </Container>
  );
};

export default TimelineSection;
